import React from 'react';

import { LineChart } from '../LineChart/index';
import { RadarChart } from '../RadarChart/index';
import { Trans } from 'lingui-react';

export const ScoreSummary = props => {

  let topicsOrganization = null;
  let topicsTechnology = null;
  if (
    props.assessmentResult.organization.topics != null &&
    props.assessmentResult.technology.topics != null
  ) {
    let str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    topicsOrganization = props.assessmentResult.organization.topics.map(
      (element, index) => {
        return (
          <p className="chart-label" key={index}>
            {str.charAt(index)} - {element.name_en}
          </p>
        );
      }
    );
    topicsTechnology = props.assessmentResult.technology.topics.map(
      (element, index) => {
        return (
          <p className="chart-label" key={index}>
            {str.charAt(index)} - {element.name_en}
          </p>
        );
      }
    );
  }
  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <h6 className="assessment-content-first" ><Trans id="1. Rating"/></h6>
        </div>
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              <p>
                <Trans id="The evaluation of your answers results in the following quantitative assessment. This is shown against a comparative benchmark."/>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="row spacing-large-assessment-component assessment-report-component">
          <div className="col-12 col-md-5">
            <p className="topic-assessment-header"><Trans id="Total Score"/></p>
            <p className="content-pane-chart">
              <Trans id="The graph shows the score achieved against a comparative benchmark."/>
            </p>
            <div className="company-bar">
              <span className="explanation-icon" />
              <p className="content-pane-chart"><Trans id="Your Company"/></p>
            </div>
            <div className="benmark-bar">
              <span className="explanation-icon"/>
              <p className="content-pane-chart"><Trans id="Benchmark"/></p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <LineChart
              chartData={props.chartDataLine}
              location="Massachusetts"
              legendPosition="bottom"
            />
          </div>
        </div>
        <hr/>
        <div className="row spacing-large-assessment-component assessment-report-component">
          <div className="col-12 col-md-4">
            <p className="topic-assessment-header"><Trans id="Organization Topics"/></p>
            <p className="content-pane-chart">
              <Trans id="The graph shows the score achieved against a comparative benchmark."/>
            </p>
            <div className="company-bar">
              <span className="explanation-icon"/>
              <p className="content-pane-chart"><Trans id="Your Company"/></p>
            </div>
            <div className="benmark-bar">
              <span className="explanation-icon"/>
              <p className="content-pane-chart"><Trans id="Benchmark"/></p>
            </div>
            <div className="description-table">{topicsOrganization}</div>
          </div>
          <div className="col-12 col-md-8">
            <RadarChart
              chartData={props.chartDataOrganization}
              location="Organization Topics"
              legendPosition="bottom"
            />
          </div>
        </div>
        <hr/>
        <div className="row spacing-large-assessment-component assessment-report-component">
          <div className="col-12 col-md-5">
            <p className="topic-assessment-header"><Trans id="Technology Topics"/></p>
            <p className="content-pane-chart">
              <Trans id="The graph shows the score achieved against a comparative benchmark."/>
            </p>
            <div className="company-bar">
              <span className="explanation-icon"/>
              <p className="content-pane-chart"><Trans id="Your Company"/></p>
            </div>
            <div className="benmark-bar">
              <span className="explanation-icon"/>
              <p className="content-pane-chart"><Trans id="Benchmark"/></p>
            </div>
            <div className="description-table">{topicsTechnology}</div>
          </div>
          <div className="col-12 col-sm-7">
            <RadarChart
              chartData={props.chartDataTechnology}
              location="Technology Topics"
              legendPosition="bottom"
            />
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/AssessmentReport/components/ScoreSummary/ScoreSummary.js